<!--
Items:
[{id:9,name:'titel',path:'http://www.quantumfrog.de/logo.png'}]
-->
<template>
<div class="component">
    <div class="slideshowImageContainer">
        <transition :name="currentTransition">
            <slideitem :key="selectedImage.id" class="slideItem" :image="selectedImage"></slideitem>
        </transition>
    </div>
    <div class="sliderNavigation">
        <div class="navigationArrow arrowLeft"><i class="fas fa-arrow-left" @click="clickPrev()"></i></div>
        <div class="navigationArrow arrowRight"><i class="fas fa-arrow-right" @click="clickNext()"></i></div>

    </div>
</div>
</template>

<script>
import slideitem from '@/components/Slideshow/slideitem.vue'

export default {
    name: 'Slideshow',
    props: ["items"],
    components: {
        slideitem
    },
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            activeSlide: -1,
            currentTransition: "transitionRight"
        }
    },
    methods: {
        clickPrev() {
            this.activeSlide--;
            this.currentTransition = 'transitionRight'
        },
        clickNext() {
            this.activeSlide++;
            this.currentTransition = 'transitionLeft'

        },
    },
    computed: {
        selectedImage() {
            if (this.activeSlide >= this.items.length) {
                this.activeSlide = 0
            }

            if (this.activeSlide < 0) {
                this.activeSlide = this.items.length - 1
            }

            return this.items[this.activeSlide]
        }
    },
}
</script>

<style scoped>
.sliderNavigation {
    position: absolute;
    width: 100%;
    left: 0;
    
    padding: 0 20px;
    bottom: 50%;
    transform: translateY(-50%);
}

.navigationArrow {
    display: inline-block;
    width: 50%;
    font-size: 4em;

}

.arrowLeft {
    text-align: left;
}

.arrowRight {
    text-align: right;
}

.slideItem {
    max-width: 90%;
    margin: auto;
}

.slideshowImageContainer {
    height: 350px;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
    width:80%;
    margin:auto;
    border: 1px solid #f0f0f0;

}

.transitionRight-enter-active,
.transitionRight-leave-active {
    transition: all .4s;
    display: inline-block;
    position: absolute;
    width: 90%;

}

.transitionRight-leave,
.transitionRight-enter-to {
    right: 5%;
}

.transitionRight-enter {
    right: 95%;
}

.transitionRight-leave-to {
    right: -100%;
}

.transitionLeft-enter-active,
.transitionLeft-leave-active {
    transition: all .4s;
    display: inline-block;
    position: absolute;
    width: 100%;
}

.transitionLeft-leave,
.transitionLeft-enter-to {
    left: 5%;
}

.transitionLeft-enter {
    left: 95%;
}

.transitionLeft-leave-to {
    left: -100%;
}
</style>
